import { OrganizationKeyName } from "../../../model/Organization";

export const GET_USER_TERM_VERSION_LIST = "GET_USER_TERM_VERSION_LIST";
export type GetUserTermVersionListAction = {
  type: typeof GET_USER_TERM_VERSION_LIST;
  organization: OrganizationKeyName;
  userTermId: string;
};
export const getUserTermVersionListAction = (
  organization: OrganizationKeyName,
  userTermId: string
): GetUserTermVersionListAction => ({
  type: GET_USER_TERM_VERSION_LIST,
  organization,
  userTermId,
});

export const GET_USER_TERM_VERSION_LIST_FAIL =
  "GET_USER_TERM_VERSION_LIST_FAIL";
export type GetUserTermVersionListFailAction = {
  type: typeof GET_USER_TERM_VERSION_LIST_FAIL;
  organization: OrganizationKeyName;
  userTermId: string;
};
export const getUserTermVersionListFailAction = (
  organization: OrganizationKeyName,
  userTermId: string
): GetUserTermVersionListFailAction => ({
  type: GET_USER_TERM_VERSION_LIST_FAIL,
  userTermId,
  organization,
});

export const GET_USER_TERM_VERSION_LIST_SUCCESS =
  "GET_USER_TERM_VERSION_LIST_SUCCESS";
export type GetUserTermVersionListSuccessAction = {
  type: typeof GET_USER_TERM_VERSION_LIST_SUCCESS;
  organization: OrganizationKeyName;
  userTermId: string;
  data: any;
};
export const getUserTermVersionListSuccessAction = (
  organization: OrganizationKeyName,
  userTermId: string,
  data: any
): GetUserTermVersionListSuccessAction => ({
  type: GET_USER_TERM_VERSION_LIST_SUCCESS,
  organization,
  userTermId,
  data,
});
